export const setBodyOverflow = (hidden) => {
    const body = document.body;
    if (body) {
        body.style.overflow = hidden ? 'hidden' : 'visible';
    }
};
